var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Agent } from "./Agent";
export class SearchResult {
  constructor(_data) {
    /**
     */
    __publicField(this, "Agents");
    /**
     */
    __publicField(this, "Count");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof SearchResult
     */
    __publicField(this, "$type", "V1.Agents.Search.SearchResult");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      if (_data["Agents"] && _data["Agents"].constructor === Array) {
        this.Agents = [];
        for (let item of _data["Agents"]) {
          const agents_ = new Agent();
          this.Agents.push(agents_.init(item));
        }
      }
      this.Count = _data["Count"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    if (this.Agents && this.Agents.constructor === Array) {
      _data["Agents"] = [];
      for (let item of this.Agents) {
        _data["Agents"].push(item.toJSON());
      }
    }
    _data["Count"] = this.Count;
    return _data;
  }
}
